import { __rest } from "tslib";
import clsx from 'clsx';
import { node, string } from 'prop-types';
import React from 'react';
import { BodyText, Heading1 } from '../Type';
import './PageHeader.less';
const ACCESSIBILITY_HIDDEN = { 'aria-hidden': true };
export default function PageHeader(props) {
    const { subHeadingText, children, className, imageUrl, imageAlt, avatar, endSection } = props, otherProps = __rest(props, ["subHeadingText", "children", "className", "imageUrl", "imageAlt", "avatar", "endSection"]);
    const combinedClass = clsx('kal-page-header', (imageUrl || avatar) && 'with-avatar', subHeadingText && 'with-sub-heading', endSection && 'with-end-section', className);
    const imageProps = imageAlt ? { alt: imageAlt } : ACCESSIBILITY_HIDDEN;
    const avatarContainer = avatar ? (React.createElement("div", { className: 'avatar-container' }, avatar)) : (React.createElement("div", { className: 'avatar-container' }, imageUrl && React.createElement("img", Object.assign({ src: imageUrl }, imageProps))));
    return (React.createElement("div", Object.assign({ className: combinedClass }, otherProps),
        avatarContainer,
        React.createElement(Heading1, { className: 'heading', noTopSpacer: true }, children),
        subHeadingText && React.createElement(BodyText, { className: 'sub-heading' }, subHeadingText),
        endSection && React.createElement("div", { className: 'end-section' }, endSection)));
}
PageHeader.propTypes = {
    /** The main text content of the header */
    children: node,
    /** The text of the subheading */
    subHeadingText: node,
    /** CSS class to be applied to the main container */
    className: string,
    /** An avatar element to be shown in the header */
    avatar: node,
    /** An image to be shown with the header. Should be 1:1 aspect ratio. */
    imageUrl: string,
    /** Alt-text to be applied to the image (if present) */
    imageAlt: string,
    /** Element to be shown at the far end of the header */
    endSection: node,
};
//# sourceMappingURL=PageHeader.js.map